// Customer support contact shown in "Need help with this shipment?"
export const SUPPORT_PHONE = "+91 9712 666 666";
